import { Box, Container } from '@forgeglobal/design-framework';
import ErrorBoundary from '@tcs/common/components/atoms/ErrorBoundary';
import DataAsOfTooltip from './DataAsOfTooltip';
import { useStyles } from './style';
import { SvgIconProps } from '@mui/material/SvgIcon';
import useDataAsOfDate from '@tcs/client-portal-common/hooks/useDataAsOfDate';
import { getDateOnly } from '@tcs/client-portal-common/utils/formatDate';
import { useMemo } from 'react';

interface Props {
  label: string;
  children: JSX.Element;
  icon?: SvgIconProps;
  iconPosition?: 'top' | 'bottom' | 'start' | 'end';
}

const TabContent = ({ children, ...rest }: Props) => {
  const classes = useStyles();
  const dataAsOfDate = useDataAsOfDate();

  const note = useMemo(() => {
    return dataAsOfDate
      ? 'Last updated ' + getDateOnly(dataAsOfDate.toISOString())
      : '';
  }, [dataAsOfDate]);

  return (
    <ErrorBoundary>
      <div className={classes.root} {...rest}>
        <div className={classes.outer}>
          {note && rest.label !== 'Reports' ? (
            <DataAsOfTooltip note={note} />
          ) : (
            <Box className={classes.withoutNote} />
          )}
          <Container maxWidth="lg" disableGutters className={classes.inner}>
            {children}
          </Container>
        </div>
      </div>
    </ErrorBoundary>
  );
};

export default TabContent;
